import {Injectable} from '@angular/core';
import {CommandAction} from '../../../../core/command/commandAction';
import {PartnerSummaryModel, PartnerType} from '../model/partnerSummary.model';

@Injectable({providedIn: 'root'})
export class PartnerCommandService {

    constructor() {
    }

    partnerHome(partnerSummary: PartnerSummaryModel): CommandAction {
        if (partnerSummary.hasType(PartnerType.PARTNER_TYPE_PATIENT)) {
            return this.patientHome(partnerSummary);
        } else if (partnerSummary.hasType(PartnerType.PARTNER_TYPE_PRACTITIONER)) {
            return new CommandAction('podopro-app/praticiens/' + partnerSummary.id + '/main', null, null, false);
        } else if (partnerSummary.hasType(PartnerType.PARTNER_TYPE_CUSTOMER)) {
            return new CommandAction('mawi-erp-app/clients/' + partnerSummary.id, null, null, false);
        } else if (partnerSummary.hasType(PartnerType.PARTNER_TYPE_CARE_HOME)) {
            return new CommandAction('podopro-app/ehpads/' + partnerSummary.id + '/accueil', null, null, false);
        } else if (partnerSummary.hasType(PartnerType.PARTNER_TYPE_TUTOR)) {
            return new CommandAction('podopro-app/tuteurs/' + partnerSummary.id + '/accueil', null, null, false);
        } else if (partnerSummary.hasType(PartnerType.PARTNER_TYPE_HEALTH_INSURANCE)) {
            return new CommandAction('podopro-app/mutuelles/' + partnerSummary.id + '/patients', null, null, false);

        }
        return new CommandAction('app/partners/' + partnerSummary.id);
    }

    patientHome(partnerSummary: PartnerSummaryModel): CommandAction {
        return new CommandAction('patients/' + partnerSummary.id, null, null, true);
    }
}
